export const necCountryCodes: { [key: string]: string } = {
    AT: "O",
    AL: "A",
    BE: "B",
    BG: "V",
    BA: "W",
    BY: "3",
    HR: "H",
    HU: "M",
    SI: "L",
    PL: "Z",
    SK: "Q",
    CZ: "C",
    DE: "D",
    FR: "F",
    NL: "N",
    RO: "R",
    CH: "S",
    DK: "K",
    ES: "E",
    GB: "3",
    GR: "G",
    IT: "I",
    LU: "1",
    LT: "6",
    MA: "2",
    MD: "7",
    MK: "Y",
    NO: "9",
    PT: "P",
    RU: "4",
    SE: "8",
    UA: "U",
    ME: "0",
    RS: "J",
    XX: "X",
};

export const directionOptions = [
    { key: "DIRECT", value: "DIRECT", text: "DIRECT" },
    { key: "OPPOSITE", value: "OPPOSITE", text: "OPPOSITE" },
];

export const countryOptions = [
    { key: "AT", value: "AT", text: "Austria" },
    { key: "AL", value: "AL", text: "Albania" },
    { key: "BE", value: "BE", text: "Belgium" },
    { key: "BG", value: "BG", text: "Bulgaria" },
    { key: "BA", value: "BA", text: "Bosnia and Herzegovina" },
    { key: "BY", value: "BY", text: "Belarus" },
    { key: "HR", value: "HR", text: "Croatia" },
    { key: "CZ", value: "CZ", text: "Czech Republic" },
    { key: "DK", value: "DK", text: "Denmark" },
    { key: "FR", value: "FR", text: "France" },
    { key: "DE", value: "DE", text: "Germany" },
    { key: "GB", value: "GB", text: "Great Britain" },
    { key: "GR", value: "GR", text: "Greece" },
    { key: "HU", value: "HU", text: "Hungary" },
    { key: "IT", value: "IT", text: "Italy" },
    { key: "LT", value: "LT", text: "Lithuania" },
    { key: "LU", value: "LU", text: "Luxembourg" },
    { key: "MD", value: "MD", text: "Moldavia" },
    { key: "ME", value: "ME", text: "Montenegro" },
    { key: "MA", value: "MA", text: "Morocco" },
    { key: "NL", value: "NL", text: "Netherlands" },
    { key: "MK", value: "MK", text: "North Macedonia" },
    { key: "NO", value: "NO", text: "Norway" },
    { key: "PL", value: "PL", text: "Poland" },
    { key: "PT", value: "PT", text: "Portugal" },
    { key: "RO", value: "RO", text: "Romania" },
    { key: "RU", value: "RU", text: "Russia" },
    { key: "RS", value: "RS", text: "Serbia" },
    { key: "SK", value: "SK", text: "Slovakia" },
    { key: "SI", value: "SI", text: "Slovenia" },
    { key: "ES", value: "ES", text: "Spain" },
    { key: "SE", value: "SE", text: "Sweden" },
    { key: "CH", value: "CH", text: "Switzerland" },
    { key: "UA", value: "UA", text: "Ukraine" },
    { key: "XX", value: "XX", text: "Other" },
];

export const sourceFileOptions = [
    { key: "CGM", value: "CGM", text: "CGM" },
    { key: "F301", value: "F301", text: "F301" },
];

export const lortOptions = [
    { key: "##L", value: "##L", text: "Lines" },
    { key: "##T", value: "##T", text: "Transformers" },
];

export const voltageOptions = [
    { key: "2", value: "2", text: "220 kV" },
    { key: "8", value: "8", text: "330 kV" },
    { key: "1", value: "1", text: "380 kV" },
    { key: "9", value: "9", text: "500 kV" },
    { key: "0", value: "0", text: "750 kV" },
];

export const ccValidationModes = [
    { key: "additional-outage", value: "additional-outage", text: "Add additional outage" },
    { key: "nec-cgm", value: "nec-cgm", text: "Create additional NEC from CGM" },
    { key: "nec-cb", value: "nec-cb", text: "Select additional NEC from CB file" },
];
